import styled from 'styled-components';

import { ErrorMessage, Field } from 'formik';
import { ListSubheader, MenuItem, Select } from '@mui/material';

const DefaultSelect = (props) => {
    const {
        name,
        label,
        options,
        placeholder,
        groupBy,
        valueKey = 'id',
        labelKey = 'name',
        ...rest
    } = props;

    const getGroupedOptions = () => {
        if (!groupBy || !options) return null;

        const grouped = {};

        options.forEach((option) => {
            const category = option[groupBy] || 'Otros';
            if (!grouped[category]) {
                grouped[category] = [];
            }
            grouped[category].push(option);
        });

        return grouped;
    };

    const groupedOptions = groupBy ? getGroupedOptions() : null;

    return (
        <InputWrapper>
            {label && <Label>{label}</Label>}

            <Field
                as={Select}
                name={name}
                variant="standard"
                color="primary"
                size="small"
                fullWidth
                displayEmpty
                {...rest}
            >
                {placeholder && (
                    <MenuItem value="" disabled>
                        {placeholder}
                    </MenuItem>
                )}

                {groupedOptions
                    ? Object.entries(groupedOptions).map(
                          ([category, items]) => [
                              <ListSubheader
                                  key={`header-${category}`}
                                  sx={{
                                      fontWeight: 600,
                                      color: '#b31d15',
                                      fontSize: '0.95rem',
                                      lineHeight: '2.5rem',
                                  }}
                              >
                                  {category}
                              </ListSubheader>,
                              ...items.map((option) => {
                                  const value = option[valueKey];
                                  const label = option[labelKey];

                                  return (
                                      <MenuItem
                                          value={value}
                                          key={value}
                                          sx={{ pl: 4 }}
                                      >
                                          {label}
                                      </MenuItem>
                                  );
                              }),
                          ]
                      )
                    : options?.map((option) => {
                          const value = option[valueKey];
                          const label = option[labelKey];

                          return (
                              <MenuItem value={value} key={value}>
                                  {label}
                              </MenuItem>
                          );
                      })}
            </Field>
            <ErrorMessage name={name} component={CustomError} />
        </InputWrapper>
    );
};

export default DefaultSelect;

const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 60px;
`;

const Label = styled.label`
    margin-bottom: 5px;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.54);
`;

const CustomError = styled.span`
    margin-top: 2px;
    font-size: 0.75rem;
    color: #b31d15;
`;
